import { logoClient } from 'myNet'
import logoDB from 'libs/DB/logoDB'

// Size: 기본값: 256 (72 | 256 | 1024) 이외 값은 에러
export function download(domain, size, onProgress, onBeforeSend) {
  const params = {}

  if (size != null) {
    params.size = size
  }

  const onBeforeSendNew = (xhr) => {
    xhr.responseType = 'blob'

    if (onBeforeSend != null) {
      onBeforeSend(xhr)
    }
  }

  const options = {
    headers: {
      crauth: '3e6cb4dbca5613b723a68d5070cc092da1d839ca5977214cc22a76d2fb2ae224',
    },
  }

  const promise = new Promise((resolve, reject) => {
    logoClient
      .xhrGet(`/logo/download/${domain}/`, params, onProgress, onBeforeSendNew, options)
      .then(({ xhr }) => {
        console.log('xhrGetFile', xhr)

        let blob = xhr.response

        if (blob.type === 'application/json') {
          console.log(' --- download error : is not image')
          reject(new Error('is not image.'))
          return
        }

        let downloadBlob = blob
        const mimetype = xhr.getResponseHeader('file-content-type')
        const dispositionValue = xhr.getResponseHeader('content-disposition')

        let fileName = null
        if (dispositionValue != null) {
          const pairs = dispositionValue.split(';')

          const map = {}
          pairs.forEach((text) => {
            const subPairs = text.trim().split('=')
            if (subPairs.length > 1) {
              map[subPairs[0].trim()] = subPairs[1].trim().replace(/["']/g, '')
            } else {
              map[subPairs[0].trim()] = null
            }
          })

          fileName = map.filename
        }

        if (mimetype != null) {
          downloadBlob = new Blob([blob], { type: mimetype })
        }

        const ret = {
          downloadPath: window.URL.createObjectURL(downloadBlob),
        }

        ret.download = () => {
          console.log(' - downloadImg : ', fileName, ret.downloadPath)
          const link = document.createElement('a')
          link.href = ret.downloadPath
          link.download = fileName
          link.click()
          link.remove() // IE 미지원
        }

        if (fileName != null || mimetype != null) {
          if (blob.type === 'text/xml' && fileName != null) {
            const lcFileName = fileName.toLowerCase()
            if (lcFileName.endsWith('.svg') === true) {
              blob = new Blob([blob], { type: 'image/svg+xml' })
              // heic 지원 안함.
              // } else if (
              //   lcFileName.endsWith('.heic') === true ||
              //   lcFileName.endsWith('.heif') === true
              // ) {
              //   const tmpFile = new File([blob], fileName, { type: mimetype || 'image/heic' })
              //   // createObjectURL에는 blob, file 모두 사용가능하므로, file을 blob 대신 전달.
              //   if (onProgress != null) {
              //     onProgress(null, null)
              //   }
              //   convertHEIC(tmpFile, 'image/jpeg', 0.8).then((imgBlob) => {
              //     console.log(imgBlob)
              //     if (onProgress != null) {
              //       onProgress(null, null)
              //     }
              //     ret.blob = imgBlob
              //     ret.path = window.URL.createObjectURL(imgBlob)
              //     resolve(ret)
              //   })

              //   return
            } else if (mimetype != null) {
              blob = new Blob([blob], { type: mimetype })
            }
          } else if (mimetype != null) {
            blob = new Blob([blob], { type: mimetype })
          }

          ret.blob = blob
          ret.path = window.URL.createObjectURL(blob)
        }

        resolve(ret)
      })
      .catch((err) => {
        // AntMessage.info('download failed.')
        console.log(' --- download error ', err)
        // @todo - error 처리. - 404 file not found.
        reject(err)
      })
  })

  return promise
}

const reqMap = {}

function getThumbIcon0(domain, size, domainKey) {
  const promise = new Promise((resolve, reject) => {
    logoDB
      .getData(domainKey)
      .then((data) => {
        // console.log(' --- image data --- ', data)
        if (data != null) {
          resolve(data.url)
          return
        }

        reject(new Error('DB error.'))
      })
      .catch((e) => {
        console.log(' --- thumb load ', e)
        setTimeout(() => {
          download(domain, size)
            .then(({ blob }) => {
              logoDB.putData(domainKey, blob).then((imgData) => {
                resolve(imgData.url)
              })
            })
            .catch(() => {
              // 1시간 동안 다시 시도하지 않음.
              logoDB.putData(domainKey, null, 60 * 60 * 1000).then((imgData) => {
                resolve(imgData.url)
              })
              // reject(new Error('Download error.'))
            })
        }, 10)
      })
  })

  return promise
}

export function getThumbIcon(domain, size) {
  const domainKey = size != null ? `${domain}_${size}` : domain

  if (reqMap[domainKey] == null) {
    reqMap[domainKey] = []
  }

  if (reqMap[domainKey].length === 0) {
    getThumbIcon0(domain, size, domainKey)
      .then((url) => {
        reqMap[domainKey].forEach(({ resolve }) => {
          resolve(url)
        })

        reqMap[domainKey] = []
      })
      .catch((e) => {
        reqMap[domainKey].forEach(({ reject }) => {
          reject(e)
        })

        reqMap[domainKey] = []
      })
  }

  const retPromise = new Promise((resolve, reject) => {
    reqMap[domainKey].push({
      resolve,
      reject,
    })
  })

  return retPromise
}

const apis = {
  download,
  getThumbIcon,
}

export default apis
